<template>
  <div id="ticketList" v-ripple :class="{selected: showSelected}">
    <template if="user">
      <vo-avatar class="avatar" :user="user" :size="32"></vo-avatar>
      <div class="left">
        <div class="name">{{ user.fullName || 'Full Name Goes Here' }}</div>
        <div class="email">{{ user.email || 'email@goeshere.com' }}</div>
      </div>
      <div class="right">
        <div class="status">{{ user.joined > 0 ? 'JOINED' : 'INVITED' }}</div>
        <div class="date">{{ (user.joined > 0 ? user.joined : user.created) | dateShorthand }}</div>
      </div>
    </template>
  </div>
</template>

<script>

  import ListItemMixin from '../mixins/listItemMixin.js' 

  export default {
    mixins: [ListItemMixin],
    data () {
      return {

      }
    },
    computed: {
      user () {
        return this.$store.getters.user(this.item);
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #ticketList {
    
    @include fontPrimary400();

    display: block;
    position: relative;
    width: 100%;
    height: 88px;
    border-bottom: 1px solid $black12;
    background: $white;

    &.selected {
      background: $lightGreen;
    }

    .avatar {
      position: absolute;
      top: 28px;
      left: 12px;
    }

    .left {
      position: absolute;
      top: 24px;
      left: 54px;
      right: 100px;
      line-height: 20px;

      .name {
        @include textEllipsis();
        
        font-size: 16px;
      }

      .email {
        @include textEllipsis();
        
        font-size: 14px;
        color: $black54;
      }

    }

    .right {
      position: absolute;
      top: 28px;
      right: 16px;
      width: 95px;
      text-align: right;
      line-height: 16px;
      font-size: 12px;
      color: $black54;
      
      .status {
        @include fontPrimary500;
        text-transform: uppercase;
      }
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/PeopleList.vue